import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import SEOHead from "@/components/SEOHead";
import { GraduationCap, Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@collegeunlock.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="admin-login-page">
      <SEOHead title="Admin Login" />
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#0B2A6B]"><GraduationCap className="h-6 w-6 text-white" /></span>
          <span className="font-display text-xl font-extrabold text-[#0B2A6B]">College<span className="text-[#D4A24C]">Unlock</span></span>
        </Link>
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <div className="flex items-center gap-2 text-slate-900"><Lock className="h-5 w-5 text-[#0B2A6B]" /><h1 className="font-display text-xl font-bold">Admin Login</h1></div>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Email</span>
              <input data-testid="admin-email-input" type="email" className="cu-login mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <label className="block">
              <span className="text-sm font-medium text-slate-700">Password</span>
              <input data-testid="admin-password-input" type="password" className="cu-login mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </label>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
            <button data-testid="admin-login-submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#0B2A6B] px-6 py-3 text-sm font-semibold text-white hover:bg-[#081E4D] disabled:opacity-60">
              {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign In"}
            </button>
          </form>
        </div>
        <p className="mt-4 text-center text-xs text-slate-400">CollegeUnlock Admin · Pune</p>
      </div>
      <style>{`.cu-login{display:block;height:3rem;width:100%;border-radius:0.5rem;border:1px solid #cbd5e1;background:#fff;padding:0 1rem;font-size:0.875rem;outline:none}.cu-login:focus{box-shadow:0 0 0 2px #0B2A6B;border-color:transparent}`}</style>
    </div>
  );
}
